import {useCallback, useMemo} from 'react';
import AnalyticsService, {
  eventNames,
} from '@/services/analytics/AnalyticsService';

export interface RecruitmentSearchFlowStartedEventParams {
  flow_id: string;
  screen_presentation_id: string;
  recruitment_screen_name: string;
  recruitment_search_id?: string;
  campaign_id?: string;
  num_results?: string;
}

function useTrackRecruitmentSearchFlowStarted() {
  const started = useCallback(
    ({
      flow_id,
      screen_presentation_id,
      recruitment_screen_name,
      recruitment_search_id = '',
      campaign_id = '',
      num_results = '',
    }: RecruitmentSearchFlowStartedEventParams) => {
      AnalyticsService.dispatchEvent(
        eventNames.RECRUITMENT_SEARCH_FLOW_STARTED,
        {
          flow_id,
          screen_presentation_id,
          recruitment_search_id,
          recruitment_screen_name,
          campaign_id,
          num_results,
        }
      );
    },
    []
  );

  return useMemo(() => ({started}), [started]);
}

export default useTrackRecruitmentSearchFlowStarted;
